import Card from './Card';
import CardHeader from './CardHeader';
import CardTitle from './CardTitle';
import CardFooter from './CardFooter';

export { CardHeader, CardTitle, CardFooter };

export default Card;
